<template>
  <layout-main-inner :title="$route.query.inspectReportId ? '编辑检验报告': '新增检验报告'">
    <template slot="action">
      <el-button
        v-if="$route.query.inspectReportId"
        type="primary"
        :loading="loading"
        @click="save">更新</el-button>
      <el-button
        v-else
        type="primary"
        :loading="loading"
        @click="add">保存</el-button>
    </template>
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">基本信息</template>
      <inspect-home-form
        v-if="inspectInfo.tradeType === 3"
        ref="form"
        v-model="inspectInfo"
        :cb="cb" />
      <inspect-outer-form
        v-if="inspectInfo.tradeType === 1"
        ref="form"
        v-model="inspectInfo"
        :cb="cb" />
    </layout-card-wrap>

    <associate-product
      v-if="inspectInfo.tradeType === 1"
      ref="product"
      v-model="inspectInfo"
      :loading="loading"
      :tradeType="inspectInfo.tradeType"
      :vendorId="inspectInfo.vendorId" />

    <associate-batch
      v-if="inspectInfo.tradeType === 3"
      ref="associate"
      v-model="inspectInfo"
      :loading="loading"
      :tradeType="inspectInfo.tradeType"
      :vendorId="inspectInfo.vendorId" />

    <template slot="footer">
      <!-- <back-button ref="back" /> -->
      <!-- <el-button
        v-if="$route.query.inspectReportId"
        type="primary"
        :loading="loading"
        @click="save">更新</el-button>
      <el-button
        v-else
        type="primary"
        :loading="loading"
        @click="add">保存</el-button> -->
    </template>
  </layout-main-inner>
</template>
<script>
import InspectHomeForm from './busi/inspect-home-form.vue'
import InspectOuterForm from './busi/inspect-outer-form.vue'
import AssociateBatch from './busi/associate-batch.vue'
import AssociateProduct from './busi/associate-product.vue'
import Utils from './busi/utils.js'
import { mapState } from 'vuex'
export default {
  name: 'InspectEdit',
  components: { InspectHomeForm, InspectOuterForm, AssociateBatch, AssociateProduct },
  props: {},
  data() {
    return {
      loading: false,
      inspectReportAudit: null,
      inspectInfo: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  watch: {},
  mounted() {
    if (this.$route.query.inspectReportId) {
      this.getinspectreport({
        vendorId: this.$route.query.vendorId,
        inspectReportId: this.$route.query.inspectReportId
      })
    } else {
      if (this.$route.query.tradeType === '1') {
        this.inspectInfo = {
          declarationCode: '',
          inspectionCode: '',
          regulatorId: this.userDetail.regulators[0],
          seaport: '',
          customsClearanceTime: '',
          inlandDealer: '',
          inlandDealerAddress: '',
          inlandDealerPhone: '',
          importer: '',
          importerAddress: '',
          importerPhone: '',
          certFile: [],
          inspectionFile: [],
          inspectReportDetails: [],
          batchs: [],
          tradeType: +this.$route.query.tradeType,
          vendorId: +this.$route.query.vendorId
        }
      } else {
        this.inspectInfo = {
          // inspectReportName: '',
          certNumber: '',
          certFile: [],
          regulatorId: this.userDetail.regulators[0],
          inspector: '',
          inspectionTime: '',
          inspectionAddress: '',
          inspectReportDetails: [],
          batchs: [],
          tradeType: +this.$route.query.tradeType,
          vendorId: +this.$route.query.vendorId
        }
      }
    }
  },
  methods: {
    cb(v) {
      this.inspectReportAudit = v
    },
    getinspectreport(config) {
      this.loading = true
      this.$store.dispatch('inspect/getinspectreport', {
        payload: config,
        success: (res) => {
          this.loading = false
          res.data.certFile = res.data.certFile.split(',').map(item => ({ url: item }))
          if (res.data.tradeType === 1) {
            // res.data.shippingTime = res.data.shippingTime ? new Date(res.data.shippingTime) : null
            res.data.inspectionFile = res.data.inspectionFile ? res.data.inspectionFile.split(',').map(item => ({ url: item })) : []
            res.data.customsClearanceTime = res.data.customsClearanceTime ? new Date(res.data.customsClearanceTime) : null
            res.data.inspectReportDetails.forEach(i => {
              const productId = i.productId
              const result = res.data.batchs.filter(s => s.productId === productId)
              i.batchs = result
            })
          } else {
            res.data.inspectionTime = res.data.inspectionTime ? new Date(res.data.inspectionTime) : null
          }
          this.inspectInfo = res.data
        },
        fail: () => {
          this.loading = false
          this.inspectInfo = {}
        }
      })
    },
    save() {
      if (this.inspectInfo.tradeType === 1) {
        this.$refs.product.submit()
          .then(data => {
            console.log(data)
            this.$refs.form.submit((res) => {
              if (!Utils.checkData(this.inspectInfo.inspectReportDetails)) {
                this.$message.error('批次商品数量不能大于报检商品数量')
                return
              }
              this.loading = true
              console.log(res)
              this.$store.dispatch('inspect/updateinspectreport', {
                payload: {
                  ...res,
                  batchIds: Utils.getIds(res),
                  inspectReportDetails: data
                },
                success: (res1) => {
                  this.loading = false
                  if (this.inspectReportAudit === 1 && res.tradeType === 1) {
                    this.applyauditinspectreport({
                      vendorId: res.vendorId,
                      inspectReportId: res1.data.inspectReportId
                    })
                  } else {
                    this.$router.go(-1)
                  }
                },
                fail: () => {
                  this.loading = false
                }
              })
            })
          })
      } else {
        this.$refs.form.submit((res) => {
          this.loading = true
          console.log(res)
          delete res.inspectReportAudit
          this.$store.dispatch('inspect/updateinspectreport', {
            payload: {
              ...res,
              batchIds: this.$refs.associate.getIds()
            },
            success: () => {
              this.loading = false
              this.$router.go(-1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
      }
    },
    add() {
      if (this.inspectInfo.tradeType === 1) {
        this.$refs.product.submit()
          .then(data => {
            console.log(data)
            this.$refs.form.submit((res) => {
              if (!Utils.checkData(this.inspectInfo.inspectReportDetails)) {
                this.$message.error('批次商品数量不能大于报检商品数量')
                return
              }
              this.loading = true
              console.log(res)
              this.$store.dispatch('inspect/addinspectreport', {
                payload: {
                  ...res,
                  batchIds: Utils.getIds(res),
                  inspectReportDetails: data
                },
                success: (res1) => {
                  this.loading = false
                  if (this.inspectReportAudit === 1 && res.tradeType === 1) {
                    this.applyauditinspectreport({
                      vendorId: res.vendorId,
                      inspectReportId: res1.data.inspectReportId
                    })
                  } else {
                    // this.$refs.back.back()
                    this.$router.go(-1)
                  }
                },
                fail: () => {
                  this.loading = false
                }
              })
            })
          })
      } else {
        this.$refs.form.submit((res) => {
          this.loading = true
          console.log(res)
          delete res.inspectReportAudit
          this.$store.dispatch('inspect/addinspectreport', {
            payload: {
              ...res,
              batchIds: this.$refs.associate.getIds()
            },
            success: () => {
              this.loading = false
              // this.$refs.back.back()
              this.$router.go(-1)
              // if (this.inspectReportAudit === 1) {
              //   this.applyauditinspectreport({
              //     vendorId: res.vendorId,
              //     inspectReportId: res1.data.inspectReportId
              //   })
              // } else {
              //   this.$refs.back.back()
              // }
            },
            fail: () => {
              this.loading = false
            }
          })
        })
      }
    },
    // 1，未检验2，检验中；3，合格；4，不合格；9，召回
    applyauditinspectreport(options) {
      this.$confirm('是否立即提交审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('inspect/applyauditinspectreport', {
          payload: options,
          success: () => {
            this.loading = false
            // this.$refs.back.back()
            this.$router.go(-1)
          },
          fail: () => {
            this.loading = false
            // this.$refs.back.back()
            this.$router.go(-1)
          }
        })
      }).catch(() => {
        // this.$refs.back.back()
        this.$router.go(-1)
      })
    }
  }
}

</script>
